
import Vue from 'vue'
import { Tooltip } from 'uiv'
import { Btn, BtnGroup } from 'uiv'

export default Vue.extend({
   name: 'RadioGroupComponent',
   props: {
      id: String,
      label: String,
      value: { required: true, type: String },
      options: { required: true, type: Array as () => NameValuePair[] },
      description: { type: String, default: '' },
      tooltip: { type: String, default: '' },
      readonly: { type: Boolean, default: false },
      hideLabel: { type: Boolean, default: false },
   },
   data() {
      return {
         initialValue: '',
         innerValue: '',
         dirty: false,
      }
   },
   computed: {
      tooltipId(): string {
         return `tooltip-${this.id}`
      },
      tooltipTargetId(): string {
         return `#${this.tooltipId}`
      },
   },
   mounted() {
      this.innerValue = this.value
      this.initialValue = this.value
   },
   watch: {
      value(newValue: string) {
         if (newValue !== this.innerValue) {
            this.innerValue = newValue
            this.initialValue = newValue
         }
      },
   },
   methods: {
      onChange() {
         if (!this.dirty) {
            this.dirty = this.innerValue !== this.value
         }
         this.$emit('input', this.innerValue)
      },
   },
   components: {
      Tooltip,
      Btn,
      BtnGroup,
   },
})
